import type { ExchangeRateDTO } from '../exchangeRate.types';

export class ExchangeRateModel {
  private readonly _dto: ExchangeRateDTO;

  constructor(dto: ExchangeRateDTO) {
    this._dto = dto;
  }

  get originDTO(): ExchangeRateDTO {
    return this._dto;
  }

  get baseCurrencyUnit(): CurrencyUnit {
    return this._dto.baseCurrencyUnit;
  }

  get createdBy(): DateTimeString {
    return this._dto.createdBy;
  }

  get createdDate(): DateTimeString {
    return this._dto.createdDate;
  }

  get creatorID(): string {
    return this._dto.creator?.id ?? '';
  }

  get creatorName(): string {
    return this._dto.creator?.name ?? '';
  }

  get creatorUserName(): string {
    return this._dto.creator?.username ?? '';
  }

  get date(): DateTimeString {
    return this._dto.date;
  }

  get exchangeRate(): number {
    return this._dto.exchangeRate;
  }

  get id(): string {
    return this._dto.id;
  }

  get source(): ExchangeRateSource {
    return this._dto.source;
  }

  get targetCurrencyUnit(): CurrencyUnit {
    return this._dto.targetCurrencyUnit;
  }

  get updateBy(): string {
    return this._dto.updateBy;
  }

  get updatedDate(): DateTimeString {
    return this._dto.updatedDate;
  }

  get updaterID(): string {
    return this._dto.updater?.id ?? '';
  }

  get updaterName(): string {
    return this._dto.updater?.name ?? '';
  }

  get updaterUserName(): string {
    return this._dto.updater?.username ?? '';
  }
}
